import ApiBase from './api-base'

class BeautyPass extends ApiBase {
  constructor () {
    super()
    this.url = '/v2/beauty_pass_pages'
  }

  async fetchPage () {
    const { data } = await this.client.get(this.url, {
      params: { include: 'beauty_pass_page_country,accumulate_points_bullets,membership_level_perks,faqs' }
    })
    return data
  }
}

export default BeautyPass
